import { render, staticRenderFns } from "./EditorSeparator.vue?vue&type=template&id=61f6f8d2&"
import script from "./EditorSeparator.vue?vue&type=script&lang=js&"
export * from "./EditorSeparator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports